import Login from './LoginContainer'

export default Login
